import React, { useState, useEffect } from 'react';
import '../components/AdminJobs.css'; // Applying consistent styles
const AdminJobs = () => {
    const [authenticated, setAuthenticated] = useState(
        localStorage.getItem("adminAuth") === "true"
    );
    const [password, setPassword] = useState("");
    const [jobs, setJobs] = useState([]);
    const [editingJob, setEditingJob] = useState(null);
    const [newJob, setNewJob] = useState({
        title: '',
        location: '',
        department: '',
        jobType: '',
        postedDate: new Date().toISOString().split('T')[0],
        description: '',
        responsibilities: '',
        requirements: '',
        benefits: ''
    });

    useEffect(() => {
        const storedJobs = JSON.parse(localStorage.getItem("adminJobs")) || [];
        setJobs(storedJobs);
    }, []);

    const handleLogin = () => {
        if (password === "Tommy") {
            localStorage.setItem("adminAuth", "true");
            setAuthenticated(true);
        } else {
            alert("Incorrect password!");
        }
    };

    const handleLogout = () => {
        localStorage.removeItem("adminAuth");
        setAuthenticated(false);
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setNewJob({ ...newJob, [name]: value });
    };

    const handleAddOrUpdateJob = () => {
        let updatedJobs;
        if (editingJob) {
            updatedJobs = jobs.map(job =>
                job.id === editingJob.id ? { ...newJob, id: editingJob.id } : job
            );
            setEditingJob(null);
        } else {
            updatedJobs = [...jobs, { 
                id: (jobs.length + 1).toString(), 
                ...newJob, 
                responsibilities: newJob.responsibilities.split(','), 
                requirements: newJob.requirements.split(','), 
                benefits: newJob.benefits.split(',') 
            }];
        }
        
        setJobs(updatedJobs);
        localStorage.setItem("adminJobs", JSON.stringify(updatedJobs));
        
        setNewJob({ title: '', location: '', department: '', jobType: '', postedDate: new Date().toISOString().split('T')[0], description: '', responsibilities: '', requirements: '', benefits: '' });
    };

    const handleEditJob = (job) => {
        setNewJob({
            ...job,
            responsibilities: Array.isArray(job.responsibilities) ? job.responsibilities.join(',') : job.responsibilities,
            requirements: Array.isArray(job.requirements) ? job.requirements.join(',') : job.requirements,
            benefits: Array.isArray(job.benefits) ? job.benefits.join(',') : job.benefits
        });
        setEditingJob(job);
    };

    const handleDeleteJob = (id) => {
        const updatedJobs = jobs.filter(job => job.id !== id);
        setJobs(updatedJobs);
        localStorage.setItem("adminJobs", JSON.stringify(updatedJobs));
    };

    if (!authenticated) {
        return (
            <div className="admin-login">
                <h1>Admin Login</h1>
                <input 
                    type="password" 
                    placeholder="Enter Admin Password" 
                    value={password} 
                    onChange={(e) => setPassword(e.target.value)}
                />
                <button onClick={handleLogin}>Login</button>
            </div>
        );
    }

    return (
        <div className="admin-container">
            <div className="text-right">
                <button onClick={handleLogout}>Logout</button>
            </div>
            <h1>Admin - Job Management</h1>
            
            <div className="job-form">
                <h2>{editingJob ? "Edit Job" : "Add New Job"}</h2>
                <input type="text" name="title" placeholder="Job Title" value={newJob.title} onChange={handleInputChange} required />
                <input type="text" name="location" placeholder="Location" value={newJob.location} onChange={handleInputChange} required />
                <input type="text" name="department" placeholder="Department" value={newJob.department} onChange={handleInputChange} required />
                <select name="jobType" value={newJob.jobType} onChange={handleInputChange} required>
                    <option value="">Select Job Type</option>
                    <option value="Full-time">Full-time</option>
                    <option value="Part-time">Part-time</option>
                    <option value="Contract">Contract</option>
                </select>
                <input type="date" name="postedDate" value={newJob.postedDate} onChange={handleInputChange} required />
                <textarea name="description" placeholder="Job Description" value={newJob.description} onChange={handleInputChange} required />
                <textarea name="responsibilities" placeholder="Responsibilities (comma-separated)" value={newJob.responsibilities} onChange={handleInputChange} required />
                <textarea name="requirements" placeholder="Requirements (comma-separated)" value={newJob.requirements} onChange={handleInputChange} required />
                <textarea name="benefits" placeholder="Benefits (comma-separated)" value={newJob.benefits} onChange={handleInputChange} required />
                <button onClick={handleAddOrUpdateJob}>{editingJob ? "Update Job" : "Add Job"}</button>
            </div>

            <div className="job-listings">
                <h2>Job Listings</h2>
                <table>
                    <thead>
                        <tr>
                            <th>Title</th>
                            <th>Location</th>
                            <th>Department</th>
                            <th>Type</th>
                            <th>Posted Date</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {jobs.map((job) => (
                            <tr key={job.id}>
                                <td>{job.title}</td>
                                <td>{job.location}</td>
                                <td>{job.department}</td>
                                <td>{job.jobType}</td>
                                <td>{job.postedDate}</td>
                                <td>
                                    <span className="edit-button" onClick={() => handleEditJob(job)}>Edit</span>
                                    <span className="delete-button" onClick={() => handleDeleteJob(job.id)}>Delete</span>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default AdminJobs;
